import decoratorHelper from './decorator.helper';

// Current decorator allow async function to be used in angular
// without adding unnecessary digest calls
const ngAsync = function () {
    return function (target, key, descriptor) {

        const fn = descriptor.value;
        descriptor.value = function () {
            const result = fn.apply(this, arguments);
            
            // To work our decorator we need injector, but we
            // managed to access $injectro only from angular.run
            // function
            const $injector = decoratorHelper.injector;

            $injector.invoke(($rootScope, $q) => {
                'ngInject';

                // Force new digest
                $q.when(result)
                    .then(() => $rootScope.$applyAsync());
            });
        };
    };
};

export default ngAsync;
